import cx from 'classnames';
import { SocialMediaLinks } from 'themes/common/components/NavItemSocial/SocialMediaLinks';
import { EggShapedPicture } from 'themes/organic/components';

import { Heading } from 'components/Heading';

import { TProfessional } from 'types/appointment';

import { OrganicButton } from '../OrganicButton/OrganicButton';

import s from './OrganicTeamMember.module.css';

export interface ProfessionalProps {
  className?: string;
  professional: TProfessional;
  reverse?: boolean;
  onClick: (professional: TProfessional) => void;
}

const OrganicTeamMember = ({
  className,
  professional,
  onClick,
}: ProfessionalProps) => {
  const {
    full_name,
    about,
    avatar_original,
    available_for_booking,
    assigned_services,
  } = professional;

  const socialMediaUrls = {
    facebook_url: professional.facebook_url,
    instagram_url: professional.instagram_url,
    twitter_url: professional.twitter_url,
    pinterest_url: professional.pinterest_url,
    yelp_url: professional.yelp_url,
    website_url: professional.website_url,
  };

  const isBookingEnabled =
    available_for_booking && assigned_services.length > 0;

  const handleClick = () => onClick(professional);

  return (
    <div className={cx(s.professional, className)}>
      <EggShapedPicture
        className={s.eggShapedPicture}
        src={avatar_original}
        alt={full_name}
        outline
      />

      <div className={cx(s.info)}>
        <Heading as="h3">{full_name}</Heading>
        {about && <p>{about}</p>}
        <SocialMediaLinks
          className={cx(s.socialMediaIcons)}
          urls={socialMediaUrls}
        />
        {isBookingEnabled && (
          <OrganicButton className={s.cta} onClick={handleClick}>
            book
          </OrganicButton>
        )}
      </div>
    </div>
  );
};

export { OrganicTeamMember };
